import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { IRowNode, ColDef, Column, ValueGetterParams } from 'ag-grid-community'; 
import * as jp from 'jsonpath';

import {
	IAfterGuiAttachedParams,
	IDoesFilterPassParams,
	IFilterParams,
	RowNode,
	//} from '@ag-grid-community/all-modules';
} from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'filter-cell',
    templateUrl: './boolean-filter.component.html',
    styleUrls: ['./boolean-filter.component.scss'],
    standalone: false
})
export class AgGridBooleanFilterComponent implements IFilterAngularComp {
	private valueGetter?: (node: IRowNode, column?: string | ColDef | Column) => any;

    params: IBooleanFilterParams;
    showTrueValues: boolean = true;
	showFalseValues: boolean = true;
	treatNullValuesAsFalse: boolean = false;

    @ViewChild('container', { read: ViewContainerRef, static: true }) public checkboxContainer;
    @ViewChild('trueCheckbox', { read: ViewContainerRef, static: true }) public trueCheckbox;
    @ViewChild('falseCheckbox', { read: ViewContainerRef, static: true }) public falseCheckbox;

    agInit(params: IBooleanFilterParams): void {
        //Defaults these values if not set
        if (params.falseValueDisplayFormat == null || params.falseValueDisplayFormat == undefined)
            params.falseValueDisplayFormat = "No"

        if (params.trueValueDisplayFormat == null || params.trueValueDisplayFormat == undefined)
			params.trueValueDisplayFormat = "Yes"

		if (params.treatNullValuesAsFalse != null) {
			this.treatNullValuesAsFalse = params.treatNullValuesAsFalse;
		}

        //So far we're only using this in issues widget, which is server side, and we plan to make all our widgets server side eventually, so default this to true
        if (params.isInServerSideFilterMode == null || params.trueValueDisplayFormat == undefined)
            params.isInServerSideFilterMode = true

        this.params = params;
        this.valueGetter = params.getValue;
    }

    isFilterActive(): boolean {
        return !(this.showTrueValues && this.showFalseValues);
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        //We don't worry about passing when in server side mode, because all results will have
        //have been filtered down to what we need already
        if (this.params.isInServerSideFilterMode)
            return true;
        else {
            let nodeValue = null;
            if (this.params.fieldPath)
                nodeValue = this.tryGetValue(params.node.data, this.params.fieldPath);
			else if (this.valueGetter != null) {
				nodeValue = this.valueGetter(params.node);
            }

            // if we don't want to show either true or false, only return true if value is unset
            if (!this.showTrueValues && !this.showFalseValues)
				return nodeValue == null;
			else {
				return (this.showTrueValues && nodeValue == true) || (this.showFalseValues && (nodeValue == false || (nodeValue == null && this.treatNullValuesAsFalse)));
            }
        }
    }

    getModel(): any {
        var builtFilter: IAgGridBooleanFilter = null;

        if (this.isFilterActive()) {
            builtFilter = {
                filterType: "boolean",
                type: "equals"
            };

            if (!this.showTrueValues && !this.showFalseValues)
                builtFilter.filter = null;
            else
                builtFilter.filter = this.showTrueValues;
        }

        return builtFilter;
    }

    setModel(model: IAgGridBooleanFilter): void {
        if (!model) {
            this.showFalseValues = true;
            this.showTrueValues = true;
        }
        else if (model.filter == null || model.filter == undefined) {
                this.showFalseValues = false;
                this.showTrueValues = false;
            }
            else {
                this.showFalseValues = !model.filter;
                this.showTrueValues = model.filter;
            }
    }

    afterGuiAttached(params?: IAfterGuiAttachedParams): void {
        Promise.resolve().then(() => {
            this.checkboxContainer.element.nativeElement.focus();
        });
    }

    // noinspection JSMethodCanBeStatic
    componentMethod(message: string): void {
        alert(`Alert from PartialMatchFilterComponent ${message}`);
    }

    onSelectAllChange(newValue): void {

        this.showFalseValues = newValue.target.checked;
        this.showTrueValues = newValue.target.checked;

        this.params.filterChangedCallback();
    }

    onShowTrueChange(newValue): void {     
        this.showTrueValues = newValue.target.checked;
        this.params.filterChangedCallback();        
    }
    onShowFalseChange(newValue): void {
        this.showFalseValues = newValue.target.checked;
        this.params.filterChangedCallback();
    }

    public tryGetValue(data: any, path: string): any {
        let value = "";
        try {
            value = jp.value(data, path);
        } catch (error) {
            console.error(error);
        }
        return value;
    }
}

export interface IBooleanFilterParams extends IFilterParams {
    trueValueDisplayFormat: string,
	falseValueDisplayFormat: string,
	treatNullValuesAsFalse?: boolean,
    fieldPath: string,
    isInServerSideFilterMode?: boolean,
}

export interface IAgGridBooleanFilter {
    filter?: boolean,
    type: string,
    filterType: string,
}
